<template>
  <div id="ShippingBase">
    <v-skeleton-loader
      v-if="loading"
      type="heading, divider"
    />
    <v-toolbar v-else tile extended>
      <v-toolbar-title class="headline font-weight-bold">
        <v-icon left>mdi-cube-send</v-icon>
        {{ shipment.name }}
      </v-toolbar-title>
      &nbsp; &nbsp;
      <v-spacer />
      <v-toolbar-items>
        <v-icon v-if="shipment.customer">mdi-cash-refund</v-icon>
        <ShippingForm :is-edit="true" :instance="shipment" :user-loading="userLoading" />
      </v-toolbar-items>
      <template v-slot:extension>
        <v-chip v-if="shipment.state === 'Requested'" color="amber darken-2" dark>
        <v-icon left>mdi-basket-fill</v-icon>
        {{ shipment.state }}
      </v-chip>
        <v-chip
        v-else-if="shipment.state === 'Shipped'"
        color="green darken-2"
        dark
      >
        <v-icon left>mdi-truck-delivery</v-icon>
        {{ shipment.state }}
      </v-chip>
        <v-chip v-else color="blue-grey darken-2" dark>
        <v-icon left>mdi-check-all</v-icon>
        {{ shipment.state }}
      </v-chip>
        <span class="body-1 mx-3">
          <div v-if="shipment.requester === null">
            Requested By: <b>Anonymous</b>
          </div>
          <div v-else>
            Requested By: <b>{{ shipment.requester.username }}</b>
          </div>
        </span>
      </template>

    </v-toolbar>
    <v-row justify="center">
      <v-col md="12" lg="10">
        <v-skeleton-loader
          v-if="loading"
          type="card-heading, image, article"
        />
        <div v-else>
          <v-card class="elevation-1" outlined>
            <v-tabs grow v-model="tabs">
              <v-tab
                :to="{
                  name: 'ShippingSummary',
                  params: { id: parseInt(this.id) }
                }"
              >
                Ticket
              </v-tab>
              <v-tab
                :to="{
                  name: 'ShippingPrint',
                  params: { id: parseInt(this.id) }
                }"
              >
                Printable
              </v-tab>
            </v-tabs>
            <v-card-text>
              <router-view :shipment="shipment" />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Shipping } from "../../models/Shipping";
import ShippingForm from "../../components/Shipping/ShippingForm";
import User from "../../models/User";
export default {
  name: "ShippingDetail",
  components: { ShippingForm },
  data() {
    return {
      loading: true,
      userLoading: true,
      tabs: null
    };
  },
  props: {
    id: {
      required: true
    }
  },
  computed: {
    shipment() {
      return Shipping.query()
        .with("children.batch")
        .with("children_misc")
        .with('requester')
        .find(parseInt(this.id));
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      this.userLoading = true;
      Shipping
        .$get(this.id)
        .then(() => (this.loading = false));
      User
        .$fetch()
        .then(() => (this.userLoading = false));
    }
  }
};
</script>
